export * from './src/core';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/public_api.js
// module id = 763
// module chunks = 3